import React, { forwardRef } from 'react';
import MaterialTable from 'material-table';
import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import InfoIcon from '@material-ui/icons/Info';

const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  InfoIcon: forwardRef((props, ref) => <InfoIcon {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
};

export default function MuiTable({ title, data, columns, onEdit, onInfo, onDelete, edit, grouping, ...rest }) {
  let actionOptions = [];
  const editOptions = {
    icon: () => <Edit />,
    tooltip: 'Edit',
    /* onClick: (event, rowData) => alert("You saved " + rowData.name) */
    onClick: (event, rowData) => {
      onEdit(rowData);
    },
  };

  const infoOptions = {
    icon: () => <InfoIcon />,
    tooltip: 'Info',
    /* onClick: (event, rowData) => alert("You saved " + rowData.name) */
    onClick: (event, rowData) => {
      onInfo(rowData);
    },
  };

  const delOptions = {
    icon: () => <DeleteOutline />,
    tooltip: 'Delete',
    /* onClick: (event, rowData) => alert("You saved " + rowData.name) */
    onClick: (event, rowData) => {
      onDelete(rowData);
    },
  };

  if (onEdit) {
    actionOptions.push(editOptions);
  }
  if (onInfo) {
    actionOptions.push(infoOptions);
  }
  if (onDelete) {
    actionOptions.push(delOptions);
  }

  return (
    <div style={{ maxWidth: '100%' }}>
      <MaterialTable
        icons={tableIcons}
        columns={columns}
        data={data}
        title={title}
        {...rest}
        options={{
          exportButton: true,
          exportAllData: true,
          pageSize: data.length < 10 ? 5 : 10,
          columnsButton: true,
          headerStyle: {
            fontSize: 20,
            color: '#3f51b5',
            fontWeight: 'bold',
          },
          padding: 'dense',
          grouping: grouping ? true : false,
        }}
        actions={edit ? actionOptions : undefined}
      />
    </div>
  );
}
